import gql from "graphql-tag";

export const createKnowledgeBaseSectionMutation = gql`
  mutation createKnowledgeBaseSection($name: String!) {
    createKnowledgeBaseSection(name: $name) {
      id
    }
  }
`;
